<template>
    <div class="app">
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selectedHospital: JSON.parse(localStorage.selectedHospital),
                localPoint: localStorage.locationPoint ? JSON.parse(localStorage.locationPoint) : {},
                targetPoint: localStorage.targetPoint ? JSON.parse(localStorage.targetPoint) : {},
            }
        },
        mounted() {
        },
        created() {
            this.refresh()
        },
        methods: {
            refresh: function () {
                if (!this.localPoint.longitude || !this.localPoint.latitude) {
                    this.$utils.alert('获取当前用户定位失败');
                    return
                }
                if (!this.targetPoint.longitude || !this.targetPoint.latitude) {
                    this.$utils.alert('目标经纬度获取失败');
                    return
                }
                this.driverGuide(this.localPoint, this.targetPoint)
            },

            driverGuide(startPoint, endPoint) {
                // 加载百度地图路线规划图
                // window.location.replace(`http://api.map.baidu.com/direction?origin=latlng:${startPoint.latitude},${startPoint.longitude}|name:我的位置&destination=latlng:${endPoint.latitude},${endPoint.longitude}|name:${this.selectedHospital.hospitalName}&region=彭州&coord_type=bd09ll&mode=driving&output=html&src=webapp.greatwall.mobilemedical`)
            },
        },
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// OutMap.vue?0eda14b7